import { render, staticRenderFns } from "./service_info.vue?vue&type=template&id=6482969a&scoped=true&"
import script from "./service_info.vue?vue&type=script&lang=js&"
export * from "./service_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482969a",
  null
  
)

export default component.exports